module.exports = __webpack_public_path__ + "img/winking-face-with-tongue.b9eb64bb.png";